import React from 'react';
import styled from 'styled-components';
import { maxBp, minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  ${({ theme, headerHeight = 80, trayHiddenOnDesktop }) => `
    min-height: calc(100vh - ${theme.heights.tray.mobile}px);
    background-color: #efefef;

    @media ${minBp('tablet')} {
      min-height: calc(100vh - ${headerHeight}px - ${theme.heights.tray.tablet}px);
    }

    @media ${minBp('tabletLarge')} {
      min-height: calc(100vh - ${headerHeight}px - ${theme.heights.tray.desktop}px);
    }
    
    @media ${minBp('desktop')} {
      height: calc(100vh - ${headerHeight}px - ${trayHiddenOnDesktop ? 0 : theme.heights.tray.desktop}px);
      overflow: hidden;
      display: flex;
      background: #fff;
    }
  `}
`;

export const BikeViewport = styled.div`
  ${({ isBikeSummary }) => `
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: white;

    @media ${minBp('desktop')} {
      ${
        isBikeSummary
          ? `
        display: block;
        overflow: auto;
      `
          : ``
      }
    }
  `}
`;

export const StepPane = styled.div`
  ${({ isWide, isBikeZoomed, isBikeSummary }) => `
    background-color: #efefef;
    padding-bottom: ${({ theme }) => theme.heights.tray.mobile}px;
    position: relative;

    ${
      isBikeSummary && !isWide
        ? `
      @media ${maxBp('desktop')} {
        display: none;
      }
    `
        : ``
    }
    
    ${
      isBikeZoomed
        ? `
      z-index: 101;
    `
        : ``
    }

    @media ${minBp('desktop')} {
      width: ${isWide ? '826px' : '526px'};
      padding-bottom: 0;

      ${
        isBikeSummary && !isWide
          ? `
        width: 605px;
        overflow: auto;
      `
          : ``
      }
    }
  `};
`;

export const StepTitle = styled.h3`
  margin: 0 0 10px;
  text-transform: uppercase;
  line-height: 1.25;
  font-size: 14px;
  text-align: center;

  @media ${minBp('tablet')} {
    margin: 0 0 20px;
    font-size: 25px;
  }

  @media ${minBp('tablet')} {
    margin: 0 0 10px;
    text-align: left;
  }
`;

export const StepDescription = styled.p`
  display: none;
  margin: 0 0 25px;
  color: #000;
  font-size: 15px;
  line-height: 1.4;

  @media ${minBp('desktop')} {
    display: block;
  }
`;
